import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';

// The server rejects page < 1 or > 100000 with a 400 rather than clamping, so
// clamp here and never send an out-of-range page.
export const MAX_PAGE = 100000;

export const clampPage = (page) => Math.min(Math.max(Number(page) || 1, 1), MAX_PAGE);

export const useGetCycles = (page = 1) => {
  const safePage = clampPage(page);

  const { data, error, isError, isPending, isFetching } = useQuery({
    queryKey: awardsKeys.cycles(safePage),
    queryFn: () => AwardsService.getCycles(safePage),
    retry: false,
    // Keeps the previous page on screen while the next one loads, so paging
    // does not blank the table. (v4's keepPreviousData: true was removed in v5.)
    placeholderData: keepPreviousData,
  });

  return {
    cycles: data?.items ?? [],
    page: data?.page ?? safePage,
    pageSize: data?.pageSize ?? 15,
    totalCount: data?.totalCount ?? 0,
    isPending,
    isFetching,
    isError,
    error,
  };
};
